module.exports = __webpack_public_path__ + "media/assets/svg/logos/telegram-683f9286d3746bcd152daa31d368940e.svg";